import { computed } from "vue"
import { QUALIFICATIONS } from "@/constants/QUALIFICATIONS"

export function useFeaturedQualifications(company) {
    return computed(() => {
        const apprenticeship = company.value?.apprenticeship
        const result = []

        // TOP-A kommt ausschließlich über das Flag `istopa` (die API führt es nicht mehr als Qualifikation) und steht immer vorne
        if (apprenticeship?.istopa) result.push({ ...QUALIFICATIONS.TOP_A })

        apprenticeship?.qualifications?.forEach(qualification => {
            const qual = Object.values(QUALIFICATIONS).find(q => q.key === qualification)
            if (qual) result.push(qual)
        })

        return result
    })
}
